enum CheckboxTarget {
    Unassigned,
    Myle_Documents_Empty,
    Myle_Documents_Sites,
    Myle_Documents_Clinicians,
    Myle_Documents_PortalStatus,
    Myle_Documents_SentBy,
    Myle_Documents_Classes,
    Myle_Documents_Status,
    Myle_Documents_Urgency,
    Myle_Documents_SitesControlCheck,
    Myle_Documents_OnlySelectedSites,
    Myle_Documents_PortalStatusControlCheck,
    Myle_Documents_CliniciansControlCheck,
    Myle_Documents_SentByControlCheck,
    Myle_Documents_StatusControlCheck,
    Myle_Documents_ClassControlCheck,
    Myle_Documents_UrgencyControlCheck,
    Myle_Documents_SaveSettingsCheck,
    Myle_Communications_SitesControlCheck,
    Myle_Communications_CliniciansControlCheck,
    Myle_Communications_StatusControlCheck,
    Myle_Communications_SharedWithControlCheck,
    Myle_Communications_PrioriyControlCheck,
    Myle_Communications_Clinician,
    Myle_Communications_Priority,
    Myle_Communications_Site,
    Myle_Calendar_SearchSites,
    Myle_Calendar_SiteItem,
    Myle_Calendar_SearchEmployees,
    Myle_Calendar_EmployeeItem,
    Myle_Calendar_SearchRooms,
    Myle_Calendar_RoomItem,
    Myle_Calendar_SearchEquipments,
    Myle_Calendar_ShowOnlySelectedSites,
    Myle_Calendar_PatientsAreVisible,
    Myle_Calendar_StatusAreVisible,
    Myle_Calendar_PhonesAreVisible,
    Myle_Calendar_RoomsAreVisible,
    Myle_Calendar_ContactPointsAreVisible,
    Myle_Calendar_IncludeCanceled,
    Myle_Calendar_IncludeNAM,
    Myle_Calendar_Servce5minAreVisible,
    Myle_Calendar_SitesAreVisible,
    Myle_Calendar_TriageScoreVisible,
    Myle_Calendar_SaveSettingsSelected,
    Myle_Calendar_OneLineViewSelected,
    Myle_Calendar_CollapseRulesets,
    Myle_Calendar_Appointment_IsPrintLabelOnSave,
    Myle_Calendar_OnlySelectedSites,
    Myle_Calendar_SortByScheduleSelectedEmployees,
    Myle_Calendar_Appointment_NotifyPatient,

    Myle_Calendar_PrintByDoctor_EmployeeItem,
    Myle_Calendar_PrintByDoctor_SiteItem,
    Myle_Calendar_PrintByDoctor_SearchSites,
    Myle_Calendar_PrintByDoctor_SearchEmployees,

    Myle_Communications_SharedWithClinician,
    Myle_Communications_TaskStatus,

    Myle_Communications_Recalls_IsAllSitesChecked,
    Myle_Communications_Recalls_IsAllCliniciansChecked,
    Myle_Communications_Recalls_IsClinicansDeactivatedChecked,
    Myle_Communications_Recalls_IsAllPrioritiesChecked,
    Myle_Communications_Recalls_IsAllStatusChecked,
    Myle_Communications_Recalls_Search_Site,
    Myle_Communications_Recalls_Search_Clinician,
    Myle_Communications_Recalls_Search_Priority,
    Myle_Communications_Recalls_Search_Status,

    Myle_Communications_Messages_IsAllSitesChecked,
    Myle_Communications_Messages_IsAllCliniciansChecked,
    Myle_Communications_Messages_IsAllPrioritiesChecked,
    Myle_Communications_Messages_IsAllStatusesChecked,
    Myle_Communications_Messages_IsAllSharedWithChecked,
    Myle_Communications_Messages_Search_Site,
    Myle_Communications_Messages_Search_Clinician,
    Myle_Communications_Messages_Search_Priority,
    Myle_Communications_Messages_Search_Status,
    Myle_Communications_Messages_Search_SharedWith,

    Myle_Labs_Clinicians,
    Myle_Labs_Clinicians_List2,
    Myle_Labs_Sites,
    Myle_Labs_SitesControlCheck,
    Myle_Labs_AllCliniciansPrescriptorControlCheck,
    Myle_Labs_AllCliniciansActionByControlCheck,
    Myle_Labs_ShowDeactivatedClinicians,
    Myle_Labs_SaveSettingsSelected,
    Myle_Labs_ShowAbnormalOnlysSelected,
    Myle_Labs_ShowEnrolledPatientsResults,
    Myle_Labs_Graphs,
    Myle_Labs_GraphsControl,
    Myle_Labs_PortalSentBySelectAll,
    Myle_Labs_PortalSentBy,
    Myle_Labs_PortalStatusSelectAll,
    Myle_Labs_PortalStatus,
    Myle_Labs_ProcessingStatus_PendingCancelled,
    Myle_Labs_ProcessingStatus_Partial,
    Myle_Labs_ProcessingStatus_Preliminary,
    Myle_Labs_ProcessingStatus_Final,
    Myle_Labs_ProcessingStatus_Others,

    Myle_PAList_Sites,
    Myle_PAList_Clinicians,
    Myle_PAList_SitesControlCheck,
    Myle_PAList_CliniciansControlCheck,
    Myle_PAList_AppointmentStatusControlCheck,
    Myle_PAList_AppointmentStatusCheck,
    Myle_PAList_OnlySelectedSites,

    Myle_Patient_Appointment_Clinicians,
    Myle_Patient_Appointment_ServiceForClinicianList,
    Myle_Patient_Appointment_OnClickAllService,
    Myle_Patient_Appointment_OnClickOtherService,
    Myle_Patient_Appointment_Services,
    Myle_Patient_Appointment_ClinicianForServicesList,
    Myle_Patient_Appointment_CellNotification,
    Myle_Patient_Appointment_EmailNotification,
    Myle_Patient_Appointment_SendNotificationsToAllPersonalContacts,
    Myle_Patient_Appointment_RepresentativeEmailNotification,
    Myle_Patient_Appointment_RepresentativeCellNotification,

    Myle_Portfolio_MyNotes_Sites,
    Myle_Portfolio_MyNotes_Clinicians,
    Myle_Portfolio_MyNotes_SitesControlCheck,
    Myle_Portfolio_MyNotes_CliniciansControlCheck,
    Myle_Portfolio_MyNotes_StatusControlCheck,
    Myle_Portfolio_MyNotes_Status,
    Myle_Portfolio_MyNotes_OnlySelectedSites,

    Myle_Portfolio_MyConsultationRequests_SitesControlCheck,
    Myle_Portfolio_MyConsultationRequests_CliniciansControlCheck,
    Myle_Portfolio_MyConsultationRequests_StatusControlCheck,
    Myle_Portfolio_MyConsultationRequests_Status,
    Myle_Portfolio_MyConsultationRequests_Sites,
    Myle_Portfolio_MyConsultationRequests_Clinicians,
    Myle_Portfolio_MyConsultationRequests_OnlySelectedSites,

    Myle_Portfolio_MyRequests_SitesControlCheck,
    Myle_Portfolio_MyRequests_CliniciansControlCheck,
    Myle_Portfolio_MyRequests_StatusControlCheck,
    Myle_Portfolio_MyRequests_Status,
    Myle_Portfolio_MyRequests_Sites,
    Myle_Portfolio_MyRequests_Clinicians,
    Myle_Portfolio_MyRequests_OnlySelectedSites,

    Myle_Portfolio_MySentFaxes_SitesControlCheck,
    Myle_Portfolio_MySentFaxes_CliniciansControlCheck,
    Myle_Portfolio_MySentFaxes_Status,
    Myle_Portfolio_MySentFaxes_Sites,
    Myle_Portfolio_MySentFaxes_Clinicians,
    Myle_Portfolio_MySentFaxes_OnlySelectedSites,
    Myle_Portfolio_MySentFaxes_IncludeIgnoredCheckboxChange,

    Myle_Portfolio_PendingApproval_Sites,
    Myle_Portfolio_PendingApproval_Clinicians,
    Myle_Portfolio_PendingApproval_SitesControlCheck,
    Myle_Portfolio_PendingApproval_CliniciansControlCheck,
    Myle_Portfolio_PendingApproval_StatusControlCheck,
    Myle_Portfolio_PendingApproval_Status,
    Myle_Portfolio_PendingApproval_OnlySelectedSites,

    Myle_Portfolio_PortalSyncHistory_Sites,
    Myle_Portfolio_PortalSyncHistory_Users,
    Myle_Portfolio_PortalSyncHistory_ItemTypes,
    Myle_Portfolio_PortalSyncHistory_Statuses,

    Myle_Billing_Transactions_Sites,
    Myle_Billing_Transactions_BilledBy,
    Myle_Billing_Transactions_SitesControlCheck,
    Myle_Billing_Transactions_ProviderControlCheck,
    Myle_Billing_Transactions_BilledByControlCheck,
    Myle_Billing_Transactions_StatusControlCheck,
    Myle_Billing_Transactions_Status,
    Myle_Billing_Transactions_PaymentMethod,
    Myle_Billing_Transactions_OnlySelectedSites,
    Myle_Billing_Transactions_PaymentsControlCheck,
    Myle_Billing_Transactions_Provider,

    Myle_Billing_Sales_Sites,
    Myle_Billing_Sales_BilledBy,
    Myle_Billing_Sales_SitesControlCheck,
    Myle_Billing_Sales_ProviderControlCheck,
    Myle_Billing_Sales_BilledByControlCheck,
    Myle_Billing_Sales_StatusControlCheck,
    Myle_Billing_Sales_Status,
    Myle_Billing_Sales_PaymentMethod,
    Myle_Billing_Sales_OnlySelectedSites,
    Myle_Billing_Sales_PaymentsControlCheck,
    Myle_Billing_Sales_Provider,

    Myle_Billing_Settings_Validity,
    Myle_Billing_Settings_ValidityAllChecked,

    Myle_PatientCPP_MedicationSearch_Status_AllCheck,
    Myle_PatientCPP_MedicationSearch_Status_ActiveCheck,
    Myle_PatientCPP_MedicationSearch_Status_ExpiredCheck,
    Myle_PatientCPP_MedicationSearch_Status_CeasedCheck,
    Myle_PatientCPP_MedicationSearch_Status_CompletedCheck,
    Myle_PatientCPP_MedicationSearch_Origin_AllCheck,
    Myle_PatientCPP_MedicationSearch_Origin_RxCheck,
    Myle_PatientCPP_MedicationSearch_Origin_MyleCheck,
    Myle_PatientCPP_MedicationSearch_Origin_DSQCheck,
    Myle_PatientCPP_MedicationSearch_Details_AllCheck,
    Myle_PatientCPP_MedicationSearch_Details_InstructionsCheck,
    // Myle_PatientCPP_MedicationSearch_Details_CeaseCheck,
    Myle_Admin_ServiceCombo_Sites_AllCheck,
    Myle_Admin_ServiceCombo_Sites_Check,
    Myle_Admin_ServiceCombo_Speciality_AllCheck,
    Myle_Admin_ServiceCombo_Speciality_Check,
    Myle_Admin_ServiceCombo_Type_AllCheck,
    Myle_Admin_ServiceCombo_Type_Check,
    Myle_Admin_ServiceCombo_Employees_AllCheck,
    Myle_Admin_ServiceCombo_Employees_Check,
    Myle_Admin_ServiceCombo_Status_AllCheck,
    Myle_Admin_ServiceCombo_Status_ActiveCheck,
    Myle_Admin_ServiceCombo_Status_InactiveCheck,
    Myle_Admin_Log_Users_AllCheck,
    Myle_Admin_Log_Users_Check,
    Myle_Admin_Log_ActionTypes_AllCheck,
    Myle_Admin_Log_ActionTypes_Check,
    Myle_Admin_Log_AccessReport_Check,
    Myle_Admin_Save_Display_Settings_Check,

    Myle_Portfolio_Attachmentpopup_CategoryControlCheck,
    Myle_Portfolio_Attachmentpopup_Category,
    Mytle_Admin_HideInactiveUsersLabel,
    Myle_Admin_BillableService_Sites_AllCheck,
    Myle_Admin_BillableService_Sites_Check,
    Myle_Admin_BillableService_CostCenters_AllCheck,
    Myle_Admin_BillableService_CostCenters_Check,
    Myle_Admin_BillableService_Sites_NullCheck,
    Myle_Admin_BillableService_CostCenters_NullCheck,
    Myle_Cnesst_InjurySite_Check,

    Myle_Calendar_Appointment_IsPrintCertificateOnSave,
    Myle_Labs_HideResultsFiledByColleague,
    Myle_Labs_AlwaysShowAbnormalResults
}

export { CheckboxTarget };
